import { NodeContext } from "src/types/node-context.types";

export function createFunctionWithContext(context: NodeContext, code: string) {
  const contextMap = getContextAsMap(context);
  const keys = getValidVariableNames(Object.keys(contextMap));
  const values = Object.values(contextMap);

  // eslint-disable-next-line no-new-func
  const fn = new Function(...keys, `return ${code}`);
  return () => fn(...values);
}

function getContextAsMap(context: NodeContext): Record<string, unknown> {
  return context.getAll().reduce<Record<string, unknown>>((acc, item) => {
    acc[item.name.trim()] = item.value;
    return acc;
  }, {});
}

const VAR_REPLACE_PATTERN = /[^\w$]/gi;
const VALID_VAR_PATTERN = /^[a-z$_][\w$]*$/i;

export function getValidVariableNames(names: string[]): string[] {
  return names.map((name) => {
    const withoutInvalidChars = name.replace(VAR_REPLACE_PATTERN, "_");

    const isValidName = VALID_VAR_PATTERN.test(withoutInvalidChars);
    const isReservedKeyword = reservedKeywords.has(withoutInvalidChars);

    return isValidName && !isReservedKeyword
      ? withoutInvalidChars
      : `_${withoutInvalidChars}`;
  });
}

const reservedKeywords = new Set([
  "abstract",
  "arguments",
  "await",
  "boolean",
  "break",
  "byte",
  "case",
  "catch",
  "char",
  "class",
  "const",
  "continue",
  "debugger",
  "default",
  "delete",
  "do",
  "double",
  "else",
  "enum",
  "eval",
  "export",
  "extends",
  "false",
  "final",
  "finally",
  "float",
  "for",
  "function",
  "goto",
  "if",
  "implements",
  "import",
  "in",
  "instanceof",
  "int",
  "interface",
  "let",
  "long",
  "native",
  "new",
  "null",
  "package",
  "private",
  "protected",
  "public",
  "return",
  "short",
  "static",
  "super",
  "switch",
  "synchronized",
  "this",
  "throw",
  "throws",
  "transient",
  "true",
  "try",
  "typeof",
  "var",
  "void",
  "volatile",
  "while",
  "with",
  "yield",
]);
